import { useCallback } from 'react';

const useDownloadPDF = () => {
    const downloadPDF = useCallback((base64, fileName, mimeType = 'application/octet-stream') => {
        // Convert base64 to raw data
        const binaryString = atob(base64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }

        // Create a Blob from the binary data
        const blob = new Blob([bytes], { type: mimeType });

        // Create an anchor element and trigger download
        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = fileName;

        // Append the anchor to the document and click it
        document.body.appendChild(downloadLink);
        downloadLink.click();

        // Remove the anchor from the document
        document.body.removeChild(downloadLink);
    }, []);

    return downloadPDF;
};

export default useDownloadPDF;
